<template>
    <div>
        <thin-line-pie-chart :animate="false" :percentage="row.capacity_percentage / 100"/>
    </div>
</template>

<script>
export default {
    props: ['row'],
};
</script>
